import { createRouter, createWebHashHistory, type RouteRecordRaw } from 'vue-router'
import Login from '@/views/login/LoginPage.vue'
import NotFound from '@/views/errors/NotFountPage.vue'
import Layout from '@/layout/MyLayout.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: '/dashboard',
    component: Layout,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/admin/DashboardPage.vue'),
        meta: { title: '仪表盘', requiresAuth: true }
      },
      // 网关管理
      {
        path: 'gateway/list',
        name: 'GatewayList',
        component: () => import('@/views/gateway/GatewayListPage.vue'),
        meta: { title: '网关列表', requiresAuth: true }
      },
      {
        path: 'gateway/detail/:gwId',
        name: 'GatewayDetail',
        component: () => import('@/views/gateway/GatewayDetailPage.vue'),
        meta: { title: '网关详情', requiresAuth: true }
      },
      // 采集器管理
      {
        path: 'collector/list',
        name: 'CollectorList',
        component: () => import('@/views/collector/CollectorListPage.vue'),
        meta: { title: '采集器列表', requiresAuth: true }
      },
      {
        path: 'collector/detail/:chipUid',
        name: 'CollectorDetail',
        component: () => import('@/views/collector/CollectorDetailPage.vue'),
        meta: { title: '采集器详情', requiresAuth: true }
      },
      // 数据管理
      {
        path: 'data/temp',
        name: 'TempData',
        component: () => import('@/views/data/TempDataPage.vue'),
        meta: { title: '温度数据', requiresAuth: true }
      },
      // 报警管理
      {
        path: 'alarm/list',
        name: 'AlarmList',
        component: () => import('@/views/alarm/AlarmListPage.vue'),
        meta: { title: '报警列表', requiresAuth: true }
      },
      // OTA管理
      {
        path: 'ota/manage',
        name: 'OtaPage',
        component: () => import('@/views/ota/OtaPage.vue'),
        meta: { title: '固件升级', requiresAuth: true }
      },
      // 出厂登记
      {
        path: 'deviceRegistry',
        name: 'DeviceRegistry',
        component: () => import('@/views/deviceRegistry/DeviceRegistryPage.vue'),
        meta: { title: '出厂登记', requiresAuth: true }
      },
      // 场地管理
      {
        path: 'site',
        name: 'Site',
        component: () => import('@/views/site/SitePage.vue'),
        meta: { title: '场地管理', requiresAuth: true }
      },
      // 系统管理
      {
        path: 'system/user',
        name: 'UserManagement',
        component: () => import('@/views/system/user/UserManagementPage.vue'),
        meta: { title: '用户管理', requiresAuth: true }
      },
      {
        path: 'system/role',
        name: 'RoleManagement',
        component: () => import('@/views/system/role/RoleManagementPage.vue'),
        meta: { title: '角色管理', requiresAuth: true }
      },
      {
        path: 'system/menu',
        name: 'MenuManagement',
        component: () => import('@/views/system/menu/MenuManagementPage.vue'),
        meta: { title: '菜单管理', requiresAuth: true }
      }
    ]
  },
  {
    path: '/login',
    component: Login,
    meta: { title: '登录' }
  },
  {
    path: '/:pathMatch(.*)*',
    component: NotFound,
    name: 'NotFound'
  }
]

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: routes
})

export default router
